export default ($) => {
    let $dasContent = $('#das-sso-content');
    let $loginForm  = $('#das-sso-login-form');
    let emailField  = $loginForm.find('#das-email');
    let passField   = $loginForm.find('#das-password');
    let showPass    = $loginForm.find('.js-dasShowPass');
    let $errorBox   = $('.js-dasAlert');
    let context     = '';
    let url         = window.das_params.ajaxUrl;
    let username    = '';
    let password    = '';
    let prevent     = false;

    showPass.on('click', function () {
        let _this = $(this);

        if (_this.hasClass('active')) {
            _this.removeClass('active');
            passField.attr('type', 'password')
        } else {
            _this.addClass('active');
            passField.attr('type', 'text')
        }
    });

    $loginForm.on('submit', e => {
        e.preventDefault();

        if (prevent)
            return;

        // const data = {
        //     action: 'das_login_ajax',
        //     username: 'iwuvqpqnnfkbkujavf@kvhrr.com', //TODO By default its empty, then it picks up username input value
        //     password: 'Screeners_TempPassword786ec434-80f7-4a86-837f-fec0d01eb6b9' //TODO By default its empty, then it picks up password input value
        // }

        const data = {
            action: 'das_login_ajax',
            username: emailField.val(),
            password: passField.val()
        }

        $.ajax({
            type: "post",
            dataType: "json",
            url: url,
            data: data,
            beforeSend: function () {
                $errorBox.hide().text('');
                $dasContent.addClass('fetching');
                prevent = true;
            },
            success: function(response) {
                prevent = false;
                let code = response.response.code;
                let body = JSON.parse(response.body);

                // console.log('Success', response);
                // console.log('Body: ', JSON.parse(response.body));
                //
                // console.log('Code: ', code);

                if (code === 400) {

                    if (body.error_description === 'missing email or password')
                        $errorBox.show().text('Missing email or password.');
                }

                if (code === 403) {

                    if (body.error_description === 'account not found')
                        $errorBox.show().text('Account not found.');
                    else
                        $errorBox.show().text('Incorrect username or password.');
                }

                if (code === 401 && body.context) {
                    $errorBox.hide().text('');
                    context = body.context;

                    username = data.username;
                    password = data.password;

                    $.ajax({
                        type: 'get',
                        dataType: 'html',
                        data: {
                            action: 'form_2fa'
                        },
                        url: url,
                        success: function (r) {
                            $dasContent.html(r);
                            set2FA();
                        },
                        error: function (e) {
                            console.log('Error: ', e);
                        }
                    })
                }
            },
            error: function (e) {
                console.log('Error: ', e);
            },
            complete: function () {
                $dasContent.removeClass('fetching');
            }
        });
    });

    function set2FA() {
        let $2faForm      = $('#das-sso-2fa-form');
        let $2faFormField = $2faForm.find('#2fa');
        let $errorBox = $('.js-dasAlert');

        $2faForm.on('submit', e => {
            e.preventDefault();

            if (prevent)
                return;

            const data = {
                action: 'das_2fa_ajax',
                context: context,
                challenge: $2faFormField.val() //TODO Add challenge from input here
            };

            $.ajax({
                type: "post",
                dataType: "json",
                url: url,
                data: data,
                beforeSend: function () {
                    prevent = true;
                    $errorBox.hide().text('');
                    $dasContent.addClass('fetching');
                },
                success: function(response) {
                    prevent = false;
                    let code = response.response.code;
                    let body = JSON.parse(response.body);
                    // console.log('Success', response);
                    // console.log('Body: ', JSON.parse(response.body));
                    //
                    // console.log('Code: ', code);

                    if (code === 400) {
                        if (body.error_description === 'missing context or challenge')
                            $errorBox.show().text('Missing Two Factor Authentication Code.');
                        else if (body.error_description === 'invalid challenge value')
                            $errorBox.show().text('Wrong Two Factor Authentication Code');

                        $2faFormField.val('');
                    }

                    if (code === 403) {
                        if (body.error_description === 'incorrect two factor challenge')
                            $errorBox.show().text('Incorrect two factor challenge.');

                        $2faFormField.val('');
                    }

                    //TODO Uncomment top, remove this line under comment
                    // let code = 200;

                    if (code === 200) {
                        $.ajax({
                            type: 'get',
                            dataType: 'html',
                            data: {
                                action: 'loader_html'
                            },
                            url: url,
                            beforeSend: function () {
                                $errorBox.hide().text('');
                            },
                            success: function (r) {
                                $dasContent.html(r);
                                checkUser();
                            },
                            error: function (e) {
                                console.log('Error: ', e);
                            }
                        });
                    }
                },
                error: function (e) {
                    console.log('Error: ', e);
                },
                complete: function () {
                    $dasContent.removeClass('fetching');
                }
            })
        })
    }

    function checkUser() {
        let dasLoaderMsg = $('.js-dasLoaderMsg');

        $.ajax({
            type: 'post',
            data: {
                action: 'das_check_user_ajax',
                username: username
            },
            url: url,
            beforeSend: function () {
                $errorBox.hide().text('');
                dasLoaderMsg.text('Authorizing...');
                $dasContent.addClass('fetching');
            },
            success: function (r) {
                console.log('r', r);
                let response     = r.response;
                let responseCode = response.code;
                let message      = response.message;

                // console.log('Final response check: ', response);
                // console.log('Message: ', message);

                if (responseCode === 404) {
                    dasLoaderMsg.text('User is not active on Screeners & Sentry. Please contact support for more assistance with your account.');
                    if (confirm('User is not active on Screeners & Sentry. Please contact support for more assistance with your account.')) {
                        // location.reload();
                    } else {
                        // location.reload();
                    }
                }

                if (responseCode === 200) {
                    dasLoaderMsg.text('Success! Logging in...');

                    $.ajax({
                        type: 'post',
                        data: {
                            action: 'das_get_user_inside',
                            username: username,
                            password: password
                        },
                        url: url,
                        success: function (r) {
                            if (r.success) {
                                dasLoaderMsg.text('Success!');
                                window.location = '/';
                            }
                        },
                        error: function (e) {
                            console.log('Err: ', e);
                            if (confirm('Error occured. Please try again.')) {
                                location.reload();
                            } else {
                                location.reload();
                            }
                        }
                    });
                }
            },
            error: function (xhr, error) {

            },
            complete: function () {
                $dasContent.removeClass('fetching');
            }
        });
    }
};